import { Modifier } from '../modifier';
import type { Damage } from '../damage.type';
import { healthRemove } from '../player.type';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import type { Die, DieRoller } from '../die.type';
import { StatusEffectRegistry } from '../status-effects';

export class Burning extends Modifier {
  static readonly baseTitle = 'Burning';
  static readonly baseText =
    'Take damage equal to half of stacks on reroll, then halve. Halve at end of turn.';
  static readonly baseIcon = 'fire';
  static readonly baseTags = [ModifierTags.Bane];
  static readonly basePriority = ModifierPriority.Middle;

  // Instance properties that can change
  title = Burning.baseTitle;
  text = Burning.baseText;
  icon = Burning.baseIcon;
  tags: Array<ModifierTags> = [...Burning.baseTags];
  priority = Burning.basePriority;

  modifierAdd(type: StatusEffect, stacks: number) {
    if (type === StatusEffect.Block) {
      let difference = this.stacks - stacks;
      this.removeStacks(Math.min(this.stacks, stacks));

      if (difference >= 0) {
        stacks = 0;
      } else {
        stacks = Math.abs(difference);
      }
    }
    return stacks;
  }

  rollStart(diceElements: Array<DieRoller | null | undefined>, dice: Array<Die>, roll: number) {
    if (roll !== 0) {
      var half = Math.ceil(this.stacks / 2);
      const damage: Damage = {
        value: half,
        target: this.owner,
        source: this.owner,
        dice: [],
      };

      healthRemove(damage);

      this.removeStacks(half);
    }
  }

  endTurn() {
    this.halveStacks();
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Burning, Burning);
